import logo from './logo.svg';
import './App.css';
import Home from './pages/home.js'
import About from './pages/about.js'
import Register from './pages/register/register'
import VerifyEmail from './pages/register/verify-email'
import PaymentCard from './pages/register/payment-card'
import PaymentDetail from './pages/register/payment-detail'
import Login from './pages/login'
import ForgotPasswordSendMail from './pages/forgot_password/send-mail'
import ForgotPassword from './pages/forgot_password/forgot-password'
import DashboardHome from './pages/dashboard/home'
import Dashboard from './pages/dashboard/dashboard'
import DashboardDocuments from './pages/dashboard/documents'
import DashboardSettings from './pages/dashboard/settings'
import DashboardModules from './pages/dashboard/modules'
import LessonRead from './pages/dashboard/modules-pages/lesson-read'
import Explanation from './pages/dashboard/modules-pages/explanation'
import QuizQuestion from './pages/dashboard/modules-pages/quiz-question'
import QuizPass from './pages/dashboard/modules-pages/quiz-pass'
import QuizFail from './pages/dashboard/modules-pages/quiz-fail'
import AudioPlay from './pages/dashboard/modules-pages/audio-play'
import ImageOrGif from './pages/dashboard/modules-pages/image-or-gif'
import AudioCard from './pages/dashboard/modules-pages/audio-card'
import Table from './pages/dashboard/modules-pages/table'
import CardSee from './pages/dashboard/modules-pages/card-see'
import CardHear from './pages/dashboard/modules-pages/card-hear'
import CardDo from './pages/dashboard/modules-pages/card-do'
import StudentSpeaking from './pages/dashboard/modules-pages/student-speaking'
import StudentCardCorrect from './pages/dashboard/modules-pages/student-card-correct'
import StudentCardFalse from './pages/dashboard/modules-pages/student-card-false'
import SyllableSee from './pages/dashboard/modules-pages/syllable-see'
import SyllableHear from './pages/dashboard/modules-pages/syllable-hear'
import SyllableDo from './pages/dashboard/modules-pages/syllable-do'
import SyllableStudentSpeak from './pages/dashboard/modules-pages/syllable-student-speak'
import SayVowels from './pages/dashboard/modules-pages/say-vowels'
import ListenToTeacher from './pages/dashboard/modules-pages/listen-to-teacher'
import ListenToTeacherCorrect from './pages/dashboard/modules-pages/listen-to-teacher-correct'
import ListenToTeacherWrong from './pages/dashboard/modules-pages/listen-to-teacher-wrong'
import CardVowelSee from './pages/dashboard/modules-pages/card-vowel-see'
import CardVowelHear from './pages/dashboard/modules-pages/card-vowel-hear'
import CardVowelDo from './pages/dashboard/modules-pages/card-vowel-do'
import {BrowserRouter as Router, Route, Routes, useNavigate} from 'react-router-dom'
function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path='/' element={<Home/>} />
          <Route path='/about' element={<About/>} />
          <Route path='/register' element={<Register/>} />
          <Route path='/register/verify-email' element={<VerifyEmail/>} />
          <Route path='/register/payment-card' element={<PaymentCard/>} />
          <Route path='/register/payment-detail' element={<PaymentDetail/>} />
          <Route path='/login' element={<Login/>} />
          <Route path='/forgot-password/send-mail' element={<ForgotPasswordSendMail/>} />
          <Route path='/forgot-password' element={<ForgotPassword/>} />

          {/*Dashboard Route*/}
          <Route path='/dashboard-home' element={<DashboardHome/>} />
          <Route path='/dashboard' element={<Dashboard/>} />
          <Route path='/dashboard/documents' element={<DashboardDocuments/>} />
          <Route path='/dashboard/settings' element={<DashboardSettings/>} />
          <Route path='/dashboard/modules' element={<DashboardModules/>} />



        {/*  Dashboard Modules Route*/}
          <Route path='/dashboard/modules/lesson-read' element={<LessonRead/>} />
          <Route path='/dashboard/modules/explanations' element={<Explanation/>} />
          <Route path='/dashboard/modules/quiz-question' element={<QuizQuestion/>} />
          <Route path='/dashboard/modules/quiz-pass' element={<QuizPass/>} />
          <Route path='/dashboard/modules/quiz-fail' element={<QuizFail/>} />
          <Route path='/dashboard/modules/audio-play' element={<AudioPlay/>} />
          <Route path='/dashboard/modules/image-or-gif' element={<ImageOrGif/>} />
          <Route path='/dashboard/modules/audio-card' element={<AudioCard/>} />
          <Route path='/dashboard/modules/table' element={<Table/>} />
          <Route path='/dashboard/modules/card-see' element={<CardSee/>} />
          <Route path='/dashboard/modules/card-hear' element={<CardHear/>} />
          <Route path='/dashboard/modules/card-do' element={<CardDo/>} />
          <Route path='/dashboard/modules/student-speaking' element={<StudentSpeaking/>} />
          <Route path='/dashboard/modules/student-card-correct' element={<StudentCardCorrect/>} />
          <Route path='/dashboard/modules/student-card-false' element={<StudentCardFalse/>} />
          <Route path='/dashboard/modules/syllable-see' element={<SyllableSee/>} />
          <Route path='/dashboard/modules/syllable-hear' element={<SyllableHear/>} />
          <Route path='/dashboard/modules/syllable-do' element={<SyllableDo/>} />
          <Route path='/dashboard/modules/syllable-student-speak' element={<SyllableStudentSpeak/>} />
          <Route path='/dashboard/modules/say-vowels' element={<SayVowels/>} />
          <Route path='/dashboard/modules/listen-to-teacher' element={<ListenToTeacher/>} />
          <Route path='/dashboard/modules/listen-to-teacher-correct' element={<ListenToTeacherCorrect/>} />
          <Route path='/dashboard/modules/listen-to-teacher-wrong' element={<ListenToTeacherWrong/>} />
          <Route path='/dashboard/modules/card-vowel-see' element={<CardVowelSee/>} />
          <Route path='/dashboard/modules/card-vowel-hear' element={<CardVowelHear/>} />
          <Route path='/dashboard/modules/card-vowel-do' element={<CardVowelDo/>} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
